import Repository from "./repository";
import axios from 'axios'

export default {

  data: function () {
    return {
        auth: {
          headers: {
            'Authorization': 'Basic Z2Nub2Rvb19wcm9kX3YxMjpiZTYyNDc3NS1mZGU5LTQ2OTUtODA4Zi05NmIwYTJmY2Q3OWM=',
            'Content-Type': 'application/json',
            'Access-Control-Allow-Origin': '*',
          }
        },
        bodyParams: {
          "args": [
            [
                [
                    "x_carto_ia_display",
                    "=",
                    "True"
                ],
                [
                    "x_studio_field_vuBga",
                    "!=",
                    "False"
                ]
            ],
            [
                "id",
                "x_studio_wordpress_id",
                "x_studio_field_k9Nz7",
                "x_studio_description_courte",
                "x_studio_field_vuBga",
                "x_cartoia_targetsectior",
                "x_cartoia_classification_1",
                "x_cartoia_classification_2",
                "street",
                "city",
                "zip",
                "country_id",
                "x_studio_field_7UGJk",
                "x_studio_field_vuBga",
                "is_company",
                "x_studio_map_longitude",
                "x_studio_map_latitude",
                "x_studio_url_image_sur_wordpress"
            ]
        ]
      }
    }
  },

  getEntreprises() {
    return Repository.patch('res.partner/call/search_read', this.data().bodyParams, this.data().auth)
      .then(response => {
        return response.data
      })
  },

  getSecteurs() {
    return Repository.get('x_business_target', this.data().auth)
      .then(response => {
        return response.data
      })
  },

  getDomaines() {
    return Repository.get('x_activity_domain', this.data().auth)
      .then(response => {
        return response.data
      })
  },

  postForm(form) {
    const url = 'https://gestion.digital113.fr/api/v1/carto-ia/form'
    return axios.post(url, form, this.data().auth)
      .then(response => {
        return response.data
      })
  }

  // getLocationFromAddress(address) {
  //   const api_key = 'AIzaSyDFCl1qvN8gJ0YG_DaPzYVCb6R5gTM4wF4'
  //   return GoogleRepository.get(`geocode/json?address=${address}&key=${api_key}`)
  //     .then(response => {
  //       console.log(response.data.results[0].geometry.location)
  //       // return response.data.results[0].geometry.location
  //     })
  // }
}